import { BoxProps, HStack } from "@chakra-ui/react";

export function ButtonRibbon({ children, ...rest }: BoxProps) {
  return (
    <HStack gap="4px" margin="8px 0" justifyContent="end" {...rest}>
      {children}
    </HStack>
  );
}
